import { useMemo, useCallback, useState } from 'react';
import { Form, ButtonToolbar } from 'react-bootstrap';
import { Table } from 'src/components/base/Table';
import { SearchField, Pane } from 'src/components/base/Elements';
import { useFetchGroups } from 'src/model/groups';
import { ITEMS_PER_PAGE } from 'src/constants';

export const GroupSelector = ({ workspace_id, filter, selectedRowIds, onSelectedRowsChange, isTwinTrap, pageSize = ITEMS_PER_PAGE }) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [sortBy, setSortBy] = useState({});
  const [search, setSearch] = useState('');

  const { data } = useFetchGroups({ workspace_id, pageSize, pageIndex, sortBy, filter, search });

  function handleFetchData({ pageIndex, sortBy }) {
    setPageIndex(pageIndex);
    setSortBy(sortBy);
  }

  function handleOnSearch(value) {
    setPageIndex(0);
    setSearch(value);
  }

  const columns = useMemo(
    () => [
      {
        Header: __('Selection'),
        accessor: 'user_id',
        disableSortBy: !filter,
        Cell: ({ row }) => <Form.Check type='checkbox' {...row.getToggleRowSelectedProps()} indeterminate="false" />
      },
      {
        Header: __('Group Name'),
        accessor: 'group_name',
      },
      {
        Header: __('Notes'),
        accessor: 'notes',
      },
    ],
    []
  );

  const getRowProps = useCallback(({ toggleRowSelected }) => (
    {
      onClick: () => toggleRowSelected(),
      className: 'cursor-pointer',
    }
  ), []);

  const getRowId = useCallback(({ group_id }) => group_id, [])

  return (
    <>
      {!isTwinTrap && <ButtonToolbar className="justify-content-between mb-3">
        <SearchField style={{ width: 350 }} value={search} onSearch={handleOnSearch} placeholder={__('Search (group name, note)')} />
      </ButtonToolbar>}

      {!isTwinTrap && <Table columns={columns} data={data.items} getRowProps={getRowProps}
        pageIndex={pageIndex} pageCount={data.pageCount} pageSize={pageSize} sortBy={sortBy}
        fetchData={handleFetchData}
        selectedRowIds={selectedRowIds} onSelectedRowsChange={onSelectedRowsChange}
        tableOptions={{ getRowId }}
      />}

      {isTwinTrap && <Pane className="mb-3">{__('It is impossible to assign groups for Twin Traps. For this type of trap, the groups of the Master Trap are automatically applied to the Twin Trap.')}</Pane>}
    </>
  )
}
